import { all, call, put, takeLeading } from 'redux-saga/effects'

import API, { CallReturnType } from '../../../api'
import { displayErrorToastSaga, ensureError } from '../../../lib'
import * as actions from './actions'

function* fetchGlobalDeliveryDays() {
  try {
    const globalDeliveryDays: CallReturnType<typeof API.fetchAllGlobalDeliveryDays> =
      yield API.fetchAllGlobalDeliveryDays()
    yield put(actions.FETCH_GLOBAL_DELIVERY_DAYS.success(globalDeliveryDays))
  } catch (e) {
    const error: CallReturnType<typeof ensureError> = yield call(ensureError, e)
    yield put(actions.FETCH_GLOBAL_DELIVERY_DAYS.failure(error))
  }
}

export function* saga() {
  yield all([
    takeLeading(actions.FETCH_GLOBAL_DELIVERY_DAYS.request, fetchGlobalDeliveryDays),
    takeLeading(actions.FETCH_GLOBAL_DELIVERY_DAYS.failure, displayErrorToastSaga),
  ])
}
